import PortalHeader from 'components/PortalHeader/PortalHeader';

interface IProgressBarsHeaderProps {
  onCreateNew: () => void;
  isCreateHidden: boolean;
}

export const ProgressBarsHeader = ({
  onCreateNew,
  isCreateHidden
}: IProgressBarsHeaderProps): React.ReactElement => {
  return (
    <PortalHeader
      title="Progress Bars"
      primaryButtonText="Create New Progress Bar"
      onPrimaryButtonClick={onCreateNew}
      isCreateButton
      primaryButtonState={{
        hidden: isCreateHidden
      }}
    />
  );
};
